export const CONVERT_BOUNDARIES_SHOW_NAME_MODAL = 'CONVERT_BOUNDARIES_SHOW_NAME_MODAL';
export const CONVERT_BOUNDARIES_HIDE_NAME_MODAL = 'CONVERT_BOUNDARIES_HIDE_NAME_MODAL';
export const CONVERT_BOUNDARIES_STOP = 'CONVERT_BOUNDARIES_STOP';
export const CONVERT_BOUNDARIES_START = 'CONVERT_BOUNDARIES_START';
